import { render, staticRenderFns } from "./SysLanguageConfigFileModal.vue?vue&type=template&id=a552387e&"
import script from "./SysLanguageConfigFileModal.vue?vue&type=script&lang=js&"
export * from "./SysLanguageConfigFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports